import {SplitText} from "gsap/SplitText";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
const isMobileFirstLoad = window.innerWidth < 768;


const tl100Days = gsap.timeline({
    scrollTrigger: {
        trigger: '.mksun-block-100-days'
    }
});

if (!isMobileFirstLoad) {
    const title100Days = new SplitText(
        '.mksun-block-100-days .timeline-text-reveal:not(.timeline-text-reveal--lines)',
        {
            type: 'words'
        }
    );

    const lines100Days = new SplitText('.mksun-block-100-days .timeline-text-reveal--lines', {
        type: 'lines'
    });

    tl100Days.fromTo('.mksun-block-100-days__ctn__introduction__img',
        {
            width: 0,
        },
        {
            width: '100%',
            onComplete: () => {
                gsap.set('.mksun-block-100-days__ctn__introduction__img__overlay', {
                    left: "unset",
                    right: 0
                })
            }
        }).to('.mksun-block-100-days__ctn__introduction__img__overlay',{
        width: 0
    })

    tl100Days.from(
        title100Days.words,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tl100Days.from(
        lines100Days?.lines,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );
}

tl100Days.to(
    '.mksun-block-100-days .btn',
    {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: 'power1.out'
    },
    '<'
);});